import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Departments } from '@/components/Departments';
import { LabTests } from '@/components/LabTests';
import { BMICalculator } from '@/components/BMICalculator';
import { PatientPortal } from '@/components/PatientPortal';
import { Footer } from '@/components/Footer';
import { FloatingWhatsApp } from '@/components/FloatingWhatsApp';
import { Admin } from '@/components/Admin';

// Home page component
const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Departments />
      <LabTests />
      <BMICalculator />
      <PatientPortal />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;